import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as accountActions } from '../../../actions/accountActions';
import { actions as supportActions } from '../../../actions/supportActions';
import { actions as fileActions } from '../../../actions/filesActions';
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import AgentTicketForm from './AgentTicketForm';
import { supportTicketStatuses } from '../../../constants/constants';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import '../supportConversation.scss';

export class AgentTicketDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            ticket: {
                id: 0,
                agentId: 0,
                agentName: "",
                description: "",
                locationName: "",
                locationAbbrev: "",
                createdByName: "",
                createdByUserName: "",
                createdByUserId: 0,
                createdDate: "",
                messages: [],
                subject: "",
                response: "",
                isInternal: false,
                statusId: 2,
                customerFileId: ""
            },
            agents: [],
            files: [],
            saveStatusType: "Solved",
            isFormValid: true,
            isLoading: false,
            isLoadingFilters: false
        }

    }

    async componentDidMount() {
        await this.loadTicketFilters();
        await this.loadTicket();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.ticketId && (this.props.ticketId !== prevProps.ticketId)) {
            this.loadTicket();
        }
    }

    onFormChange = (name, value) => {
        this.setState({ ticket: { ...this.state.ticket, [name]: value } });
    }

    async loadTicket() {
        this.setState({ isLoading: true, 
            ticket: 
            {
                ...this.state.ticket,locationName: null, locationAbbrev: null 
            } });
        try{
            const result = await this.props.supportActions.loadTicket(this.props.ticketId);
            const payload = result.payload;
            if (result.type === types.LOAD_TICKET_SUCCESS) {
                //if a ticket is created by task feedback, response is always internal
                const isInternal = payload.ticket.createdByUserId === 1;
                this.setState({
                    ticket: {
                        ...this.state.ticket, ...payload.ticket, isInternal: isInternal
                    }
                });
            } else if (result.type === types.LOAD_TICKET_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }            
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }

    }
    async loadTicketFilters() {
        this.setState({ isLoadingFilters: true });
        try{
            const result = await this.props.supportActions.loadTicketFilters();
            const payload = result.payload;
            if (result.type === types.LOAD_TICKET_FILTERS_SUCCESS) {
                this.setState({ 
                    agents: payload.agents,
                    files: payload.files
                });
            } else if (result.type === types.LOAD_TICKET_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingFilters: false });
        }

    }

    validateForm = (ticket) => {
        const { response, agentId } = ticket;

        if (response && response.trim().length > 0
            && agentId && agentId != 0) {
            return true;
        }

        return false;
    }

    onSave = async () => {
        if (this.validateForm(this.state.ticket)) {
            this.setState({ isLoading: true });
            try{
                const result = await this.props.supportActions.updateTicket(this.state.ticket);
                const payload = result.payload;
                if (result.type === types.UPDATE_SUPPORT_TICKET_SUCCESS) {
                    Notification("success", "Ticket Response Saved", "");
                    this.props.onComplete();
                } else if (result.type === types.UPDATE_SUPPORT_TICKET_FAILURE) {
                    Notification("error", "An Error Occurred", payload.message)
                }                
            } catch (error) {
                Notification("error", "Error", error);
                this.setState({ isLoading: false });
            }
        } else {
            this.setState({ isFormValid: false });
        }
    }

    onChangeSaveType = (e) => {
        this.onFormChange("statusId", parseInt(e.target.value));
    }

    buildDrawerFooterButtons = () => {
        return <div className="row agent-ticket-drawer-footer">
            <div className="col-3">
                <div className="input-group-prepend pr-3">
                    <button type="button" className="btn btn-primary mt-1 pr-3" onClick={this.onSave}>Save</button>
                </div>
            </div>
            <div className="col-6">
                <select id="inputGroupSelect01" className="form-select inputGroupSelect" onChange={this.onChangeSaveType} defaultValue={supportTicketStatuses.Pending}>
                    <option value={supportTicketStatuses.Solved}>as Solved</option>
                    <option value={supportTicketStatuses.Pending}>as Pending</option>
                </select>
            </div>
            <div className="col-3">
                <button type="button" className="btn btn-secondary mt-1" onClick={this.props.onComplete}>Cancel</button>
            </div>
        </div>
    }


    render() {

        return (
            <Drawer isWide={false}
                title='Support'
                onSaveClick={this.onSave}
                saveText="Update"
                onCancelClick={this.props.onComplete}
                customFooter={this.buildDrawerFooterButtons()}
            >
                <LoadingIndicator isLoading={this.state.isLoading || this.state.isLoadingFilters}>
                    <AgentTicketForm 
                        fileActions={this.props.fileActions}
                        ticket={this.state.ticket} 
                        agents={this.state.agents}
                        files={this.state.files}
                        onFormChange={this.onFormChange} 
                        isFormValid={this.state.isFormValid}
                        userId={this.props.currentUserId} />        
                </LoadingIndicator>
            </Drawer>
        )
    }
}

AgentTicketDrawer.propTypes = {
    ticketId: PropTypes.string.isRequired,
    currentUserId: PropTypes.number.isRequired,
    supportActions: PropTypes.object.isRequired,
    fileActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        adminUsers: state.user.adminUsers,
        currentUserId: state.user.id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        accountActions: bindActionCreators(accountActions, dispatch),
        supportActions: bindActionCreators(supportActions, dispatch),
        fileActions: bindActionCreators(fileActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentTicketDrawer);
